import { createSlice } from "@reduxjs/toolkit"
import {
  addItemTag,
  deleteItemTag,
  getItemTagDetails,
  getItemTags,
  getItemTagsList,
  updateItemTag,
  updateItemTagStatus,
} from "store/actions/itemTagsAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  itemTagsList: [],
  itemTags: [],
  itemTagDetails: {},
}

const itemTagsSlice = createSlice({
  name: "itemTags",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getItemTags.pending, state => {
        state.loading = true
      })
      .addCase(getItemTags.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.itemTags = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getItemTags.rejected, state => {
        state.loading = false
      })

    builder
      .addCase(getItemTagsList.pending, state => {
        state.loading = true
      })
      .addCase(getItemTagsList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.itemTagsList = data
        }
      })
      .addCase(getItemTagsList.rejected, state => {
        state.loading = false
      })

    builder
      .addCase(updateItemTagStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateItemTagStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.itemTags = state.itemTags.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateItemTagStatus.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(deleteItemTag.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteItemTag.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.itemTags = state.itemTags.filter(item => item._id !== id)
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteItemTag.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(addItemTag.pending, state => {
        state.isLoading = true
      })
      .addCase(addItemTag.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(addItemTag.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(updateItemTag.pending, state => {
        state.isLoading = true
      })
      .addCase(updateItemTag.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(updateItemTag.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(getItemTagDetails.pending, state => {
        state.loading = true
        state.itemTagDetails = {}
      })
      .addCase(getItemTagDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.itemTagDetails = data
        }
      })
      .addCase(getItemTagDetails.rejected, state => {
        state.loading = false
      })
  },
})

export default itemTagsSlice.reducer
